var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "pin-intro" },
        [
          _c("el-tag", { attrs: { size: "small" } }, [
            _vm._v(_vm._s(_vm.total) + " pin"),
          ]),
          _c(
            "span",
            { staticClass: "muted", staticStyle: { "margin-left": "10px" } },
            [
              _vm._v(
                " A pin forces one specific OTA build onto a user or a single cane, bypassing rollout and beta group channels entirely. "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-row" },
        [
          _c("el-input", {
            staticStyle: { width: "280px" },
            attrs: {
              placeholder: "Search by email, name or user ID",
              size: "small",
              clearable: "",
            },
            on: { clear: _vm.handleSearch },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c("el-input", {
            staticStyle: { width: "200px", "margin-left": "10px" },
            attrs: {
              placeholder: "Cane serial (exact)",
              size: "small",
              clearable: "",
            },
            on: { clear: _vm.handleSearch },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.deviceSerial,
              callback: function ($$v) {
                _vm.deviceSerial = $$v
              },
              expression: "deviceSerial",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "220px", "margin-left": "10px" },
              attrs: { size: "small", clearable: "", placeholder: "Any build" },
              on: { change: _vm.handleSearch },
              model: {
                value: _vm.otaFileId,
                callback: function ($$v) {
                  _vm.otaFileId = $$v
                },
                expression: "otaFileId",
              },
            },
            _vm._l(_vm.otaFiles, function (f) {
              return _c("el-option", {
                key: f.id,
                attrs: { label: _vm.buildLabel(f), value: f.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "170px", "margin-left": "10px" },
              attrs: { size: "small", clearable: "", placeholder: "Any scope" },
              model: {
                value: _vm.scope,
                callback: function ($$v) {
                  _vm.scope = $$v
                },
                expression: "scope",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Whole account", value: "user" },
              }),
              _c("el-option", {
                attrs: { label: "Single cane", value: "device" },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleSearch },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleReset } },
            [_vm._v("Reset")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-row" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: { click: _vm.handleSelectAllOnPage },
            },
            [
              _vm._v(
                " Select all on page (" + _vm._s(_vm.visibleRows.length) + ") "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "danger",
                disabled: !_vm.selected.length,
                loading: _vm.clearing,
              },
              on: { click: _vm.handleBulkClear },
            },
            [
              _vm._v(
                " Remove selected pins (" + _vm._s(_vm.selected.length) + ") "
              ),
            ]
          ),
          _vm.scope
            ? _c(
                "span",
                {
                  staticClass: "muted",
                  staticStyle: { "margin-left": "10px" },
                },
                [_vm._v(" Scope filter applies to the current page only. ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "pinTable",
          attrs: {
            data: _vm.visibleRows,
            border: "",
            fit: "",
            size: "small",
            "empty-text": "No pins match",
          },
          on: { "selection-change": (rows) => (_vm.selected = rows) },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "45" } }),
          _c("el-table-column", {
            attrs: { label: "User", "min-width": "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(row.user ? row.user.email : row.userId)),
                    ]),
                    row.user
                      ? _c("div", { staticClass: "muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  (row.user.first_name || "") +
                                  " " +
                                  (row.user.last_name || "")
                                ).trim()
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Scope", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.deviceSerialNumber
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "warning" } },
                          [_vm._v("Single cane")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [_vm._v("Whole account")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Cane Serial", width: "190" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.deviceSerialNumber
                      ? _c("span", { staticClass: "serial" }, [
                          _vm._v(_vm._s(row.deviceSerialNumber)),
                        ])
                      : _c("span", { staticClass: "muted" }, [
                          _vm._v("all canes"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Pinned Build", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.otaFile
                      ? [
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "success" } },
                            [_vm._v(_vm._s(row.otaFile.applicationVersionName))]
                          ),
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-left": "4px" },
                              attrs: { size: "mini" },
                            },
                            [_vm._v(_vm._s(row.otaFile.wirelessVersionName))]
                          ),
                          row.otaFile.isPinOnly
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: { size: "mini", type: "danger" },
                                },
                                [_vm._v(" pin-only ")]
                              )
                            : _vm._e(),
                        ]
                      : _c("span", { staticClass: "muted" }, [
                          _vm._v(
                            "build #" + _vm._s(row.otaFileId) + " (deleted)"
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Reason", prop: "reason", "min-width": "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "Set By", prop: "setBy", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "Updated", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.formatDate(row.updatedAt)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Actions", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleClearOne(row)
                          },
                        },
                      },
                      [_vm._v("Remove")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "16px", "text-align": "right" },
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next",
          total: _vm.total,
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [20, 50, 100, 200],
        },
        on: {
          "current-change": _vm.handlePageChange,
          "size-change": _vm.handlePageSizeChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }